import { TSelectOption } from "@microfrontends/react-components"

export const bgColorTopNumerology = '#001744'
export const colorLabelChart = {
    hight: "#005AFF",
    middle: "#337AFF",
    low: "#5C95FF",
    orther: "#85AFFF"
}

export interface ICelebritiesList {
    avatar: string,
    fullName: string,
    jobTitle: string,
    rulingNumber: number
}
export interface IOption {
    id: string | number,
    name: string
}

export interface IFormField {
    fieldType: 'input' | 'select' | 'date'
    name: string
    label: string
    isRequired: boolean
    option?: IOption[] | null
}
export interface IValues {
    value: string
    error?: string
}
export interface IFormValues {
    [key: string]: IValues
}
export const initValues: IFormValues = {
    fullName: {
        value: '',
    },
    birthday: {
        value: '',
    },
    industry: {
        value: '',
    },
    level: {
        value: '',
    }
}
